/**
 * Brand + user-facing copy — single source of truth (FR-9.11, issue #119).
 *
 * The product is branded **Peril** (a non-infringing rename off the third-party
 * "Jeopardy!" marks — the user-facing slice of the #111 IP-risk work). The
 * distinctive show elements are renamed on-brand; the wire enums they derive from
 * (`Round`, `ClueMode`, the `finalJeopardy` pack field) are **internal identifiers
 * and deliberately unchanged** (display-only rebrand). Keeping every rendered term
 * here means a future re-steer of the wording is a one-file edit, not a scatter-hunt.
 */

/** The product wordmark, shown in the tab title, home hub, and persistent header. */
export const BRAND_NAME = 'Peril';

/** Was "Daily Double" — the hidden, wager-gated clue only the uncoverer answers. */
export const HIDDEN_PERIL = 'Hidden Peril';

/** Was "Double Jeopardy" — the second (double-value) board round. */
export const DOUBLE_PERIL = 'Double Peril';

/** Was "Final Jeopardy" — the final single-clue secret-wager round. */
export const FINAL_PERIL = 'Final Peril';
